import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Close } from "@faire/web--source/slate/icons/foundation/Close";
import * as React from "react";
import { CloseWrapper } from "../styles";
export var ClearButton = function(param) {
    var value = param.value, onClear = param.onClear, helper = param.helper;
    var strictLocalize = useStrictLocalization().strictLocalize;
    if (value && onClear) {
        return /*#__PURE__*/ _jsx(CloseWrapper, {
            onClick: onClear,
            $hasHelperText: !!helper,
            "data-test-id": "option-clear-button",
            type: "button",
            children: /*#__PURE__*/ _jsx(Close, {
                color: Core.icon.subdued,
                titleAccess: strictLocalize({
                    id: "aE+aRX",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Clear selection"
                        }
                    ]
                })
            })
        });
    }
    return null;
};
